import React, { useState } from 'react';
import { func, object } from 'prop-types';
import { sortableContainer } from 'react-sortable-hoc';
import { map, isNumber, get } from 'lodash';
import Question from './Question';
import { arrayMove } from '../../../../../utils/misc';

const SortableContainer = sortableContainer(({ children }) => {
    return <div>{children}</div>;
});

const Questions = ({ setFieldValue, values }) => {
    const [activeQuestionId, setActiveQuestionId] = useState(null);

    const keepActiveCardCurrent = () => {
        isNumber(activeQuestionId) && setActiveQuestionId(activeQuestionId);
    };

    const onSortEnd = ({ oldIndex, newIndex }) => {
        keepActiveCardCurrent();
        const newQuestions = arrayMove(get(values, 'questions'), oldIndex, newIndex);
        setFieldValue('questions', newQuestions);
    };

    return <SortableContainer onSortEnd={onSortEnd} distance={10}>
        {map(get(values, 'questions'), (question, index) => (
            <Question
                key={get(question, 'idQuestion')}
                question={question}
                index={index}
                activeQuestionId={activeQuestionId}
                setActiveQuestionId={setActiveQuestionId}
                setFieldValue={setFieldValue}
                values={values}
            />
        ))}
    </SortableContainer>;
};

Questions.propTypes = {
    setFieldValue: func,
    values: object
};

export default Questions;
